<div class="container-fluid grey-bg">
    <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-3">
            <div class="widget">
                <h6 class="widget-title font-weight-bold">
                    {{labels.tikets}}
                </h6>
                <div class="row m-0 align-items-center">
                    <div class="col-md-6 widget-left p-0 display-med">
                        <div class="wl-first">
                            <div class="form-group ">
                                <select class="se-form-control darkgrey-bg" [(ngModel)]="ticketTimeChange" (ngModelChange)="getTotalTickets('ticket')">
                                    <option *ngFor="let item of timeListDrop" value="{{item}}">{{item}}</option>
                                </select>
                            </div>
                            <p *ngIf="!widgetLoader.totalTickets" class="text-center mb-0">{{labels.closed}} : {{response.totalClosedTickets}}</p>
                        </div>
                    </div>
                    <div class="col-12 display-small mob-btns mb-2 pb-0">
                        <div class="btn-group special" role="group" aria-label="Basic example">
                            <button [ngClass]="{'active': ticketTimeChange === item}" *ngFor="let item of timeListDrop" (click)="ticketTimeChange = item;getTotalTickets('ticket')" type="button" class="btn btn-secondary">{{item}}</button>
                          </div>
                          <p *ngIf="!widgetLoader.totalTickets" class="text-center mt-2 mb-0">{{labels.closed}} : {{response.totalClosedTickets}}</p>
                    </div>                    
                    <div class="col-md-12 col-lg-6 widget-right p-0 mob-tick kedar">
                        <div class="se-loader" style="margin: 0 auto 10px;" *ngIf="widgetLoader.totalTickets"></div>
                        <div class="tablet-p" *ngIf="!widgetLoader.totalTickets">
                            <span class="primary-bold-text orange ">{{response.totalOpenTickets}}</span>
                            <span>{{labels.open}}</span>
                        </div>
                        <span class="smallFont" *ngIf="response.highPriorityTickets">{{labels.high}} : {{response.highPriorityTickets}}  <br/></span>
                        <span class="smallFont" *ngIf="response.mediumPriorityTickets">{{labels.medium}} : {{response.mediumPriorityTickets}} <br/></span>
                        <span class="smallFont" *ngIf="response.lowPriorityTickets">{{labels.low}} : {{response.lowPriorityTickets}} </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-3">
            <div class="widget">
                <h6 class="widget-title font-weight-bold">
                    {{labels.totalUsers}}
                </h6>
                <div class="row m-0 align-items-center">
                    <div class="col-md-5 col-lg-5 widget-left p-0">
                        <div class="wl-first">
                            <div class="form-group">
                                <span>{{labels.servicePortal}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-5 widget-right p-0 usersTabView">
                        <div class="se-loader se-loader-center" style="margin: 0 auto;" *ngIf="widgetLoader.totalUsers"></div>
                        <p *ngIf="!widgetLoader.totalUsers">
                            <span class="primary-bold-text green">{{response.totalUsers}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-3">
            <div class="widget">
                <h6 class="widget-title font-weight-bold">
                    {{labels.accessedApps}}
                </h6>
                <div class="row m-0 align-items-center">
                    <div class="col-md-6 widget-left p-0 display-med">
                        <div class="wl-first">
                            <div class="form-group">
                                <select class="se-form-control darkgrey-bg" [(ngModel)]="accessedAppId" (ngModelChange)="getNumberOfUserAccessed()">
                                    <option value="0">All</option>
                                    <option *ngFor="let app of webApplications" value="{{app.value}}">{{app.key}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 display-small mob-btns mb-2">
                        <div class="btn-group special" role="group" aria-label="Basic example">
                            <button [ngClass]="{'active': accessedAppId === 0}"
                                (click)="accessedAppId = 0;getNumberOfUserAccessed()"
                                type="button" class="btn btn-secondary">
                                {{labels.all}}
                            </button>
                            <button [ngClass]="{'active': accessedAppId === item.value}"
                                *ngFor="let item of webApplications"
                                (click)="accessedAppId = item.value;getNumberOfUserAccessed()"
                                type="button" class="btn btn-secondary">
                                {{item.key}}
                            </button>
                          </div>
                    </div>
                    <div class="col-md-12 col-lg-6 widget-right p-0">
                        <div class="se-loader" style="margin: 0 auto;" *ngIf="widgetLoader.userAccessCount"></div>
                        <p class="tablet-p" *ngIf="!widgetLoader.userAccessCount">
                            <span class="primary-bold-text orange">{{response.accessedApps}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-3">
            <div class="widget">
                <h6 class="widget-title font-weight-bold">
                    {{labels.appDownloads}}
                </h6>
                <div class="row m-0 align-items-center">
                    <div class="col-md-6 widget-left p-0 display-med">
                        <div class="wl-first">
                            <div class="form-group">
                                <select class="se-form-control darkgrey-bg" [(ngModel)]="downloadTime" (ngModelChange)="timeChange('download')">
                                    <option *ngFor="let item of timeListDrop" value="{{item}}">{{item}}</option>
                                </select>
                            </div>
                            <select class="se-form-control" [(ngModel)]="selectedWinApp" (ngModelChange)="timeChange('download')">
                                <option value="0">All</option>
                                <option *ngFor="let item of winApplications" value="{{item.value}}">{{item.key}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 display-small mob-btns mb-2">
                        <div class="btn-group special" role="group" aria-label="Basic example">
                            <button [ngClass]="{'active': downloadTime === item}"
                                *ngFor="let item of timeListDrop"
                                (click)="downloadTime = item;timeChange('download')"
                                type="button" class="btn btn-secondary">
                                {{item}}
                            </button>
                          </div>
                    </div>
                    <div class="col-md-12 col-lg-6 widget-right p-0">
                        <div class="se-loader" style="margin: 0 auto;" *ngIf="widgetLoader.totalDownloads"></div>
                        <p *ngIf="!widgetLoader.totalDownloads">
                            <span class="primary-bold-text green">{{response.totalDownloads}}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid pt-3 pb-3 mb-3 custom-section">
        <div class="row">
            <div class="col-sm-12">
                <div class="row align-tems-center">
                    <div class="col-md-12 text-right right-icons">
                        <span (click)="gridView = true" [ngClass]="{'active': gridView}" title="{{labels.gridView}}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16.029" height="16" viewBox="0 0 16.029 16">
                                <defs>
                                    <style>
                                        .a {
                                            fill: #626469;
                                        }
                                    </style>
                                </defs>
                                <g transform="translate(-128.5 -129.5)">
                                    <path class="a"
                                        d="M143.181,129.5H129.848a1.349,1.349,0,0,0-1.348,1.348v13.3a1.349,1.349,0,0,0,1.348,1.348h13.333a1.349,1.349,0,0,0,1.348-1.348v-13.3A1.349,1.349,0,0,0,143.181,129.5Zm-13.333.9h13.333a.449.449,0,0,1,.449.449v2.412H129.4v-2.412A.449.449,0,0,1,129.848,130.4Zm2.481,7.563v2.884H129.4v-2.884Zm-2.93-.9v-2.9h2.93v2.9Zm3.829.9h10.4v2.884h-10.4Zm0-.9v-2.9h10.4v2.9Zm-3.829,7.089v-2.408h2.93V144.6h-2.481A.45.45,0,0,1,129.4,144.152Zm13.783.449h-9.954v-2.857h10.4v2.408A.45.45,0,0,1,143.181,144.6Z" />
                                    <g transform="translate(130.318 131.36)">
                                        <path class="a"
                                            d="M219.993,219.4h-4.044a.449.449,0,0,1,0-.9h4.044a.449.449,0,1,1,0,.9Z"
                                            transform="translate(-215.5 -218.5)" />
                                    </g>
                                </g>
                            </svg>
                        </span>
                        <span (click)="generateChart()" [ngClass]="{'active': !gridView}" title="{{labels.chartView}}" >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16.029" height="16" viewBox="0 0 1024 1024">
                                <path
                                    d="M329 771c33-2 59-28 61-62V223c0-33-26-60-62-62-17 0-32 7-44 19-9 9-15 20-17 32-2 3-3 7-3 11v488c2 34 30 60 65 60zm546 92c11 0 21-10 21-21 0-12-10-22-21-22H171V190c0-12-10-21-22-21-11 0-21 9-21 21v652c0 11 10 21 21 21h726zM307 232c1-3 2-6 2-9 0-5 2-10 5-13 4-4 8-5 15-6 10 1 18 9 18 19v485c-1 11-9 20-19 21-11 0-21-9-21-20V232zm442 538c32-2 58-28 60-62V281c0-33-28-61-62-61-33 0-61 28-61 61v428c2 33 28 59 63 61zm-2-507c11 0 19 8 19 18v426c0 11-9 20-17 20-11 0-20-9-20-19V281c0-10 8-18 18-18zM539 772c33-2 58-28 60-62V442c0-34-28-61-61-61-34 0-62 27-62 61v269c2 33 28 59 63 61zm-1-348c10 0 18 8 18 18v267c0 11-9 19-17 20-11-1-20-9-20-19V442c0-10 8-18 19-18z" />
                            </svg>
                        </span>
                    </div>
                </div>
                <div class="tbl-data admin-table row" *ngIf="gridView">
                    <div class="col-sm-6 hide-in-mobile">
                        <div class="grid-layout widget">
                            <h6 class="widget-title font-weight-bold">
                                {{labels.usersAppAccessdata}}
                                <em class="float-right downloadpdf"
                                    title="Export user application access list"
                                    (click)="downloadTableOne()"
                                    (keypress)="downloadTableOne()">
                                    <img width="16" height="16" src="assets/image/download.svg"
                                        alt="download">
                                </em>
                            </h6>
                            <p-table *ngIf="!widgetLoader.tableone"
                                [columns]="colsTab1"
                                [value]="response.accessTableData"
                                #dt1
                                [responsive]="true"
                                [rowsPerPageOptions]="[10]"
                                [paginator]="true"
                                [rows]="10">
                                <ng-template pTemplate="caption">
                                    <div class="row">
                                        <div class="col-md-12 pr3">
                                            <div class="input-group search-table">
                                                <input id="userAccessData"
                                                aria-label="userAccessData"
                                                type="search" class="se-form-control"
                                                title={{labels.appSearch}}
                                                placeholder="Search"
                                                (input)="dt1.filterGlobal($event.target.value, 'contains')">
                                                <span class="se-icon-action_search_stroke search_icon"></span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}">
                                            {{col.header}}
                                            <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                                            ariaLabelDesc="Activate to sort in descending order"
                                            ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-rowData let-columns="columns">
                                    <tr class="tbl-bodyrow">
                                        <td *ngFor="let col of columns" [ngStyle]="{'width': col.width}">
                                            <span class="txtWordWrap" title="{{rowData[col.field]}}">
                                                {{rowData[col.field]}}
                                            </span>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="paginatorleft" let-state>

                                </ng-template>

                            </p-table>
                            <div class="text-center loader-box" *ngIf="widgetLoader.tableone">
                                <div class="se-loader mt-2 mb-2 ml-auto mr-auto"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6 hide-in-mobile">
                        <div class="grid-layout widget">
                            <h6 class="widget-title font-weight-bold">
                                {{labels.usersAppdownloaddata}}
                                <em class="float-right downloadpdf"
                                    title="Export application download data"
                                    (click)="downloadTableTwo()"
                                    (keypress)="downloadTableTwo()">
                                    <img width="16" height="16" src="assets/image/download.svg"
                                    alt="download">
                                </em>
                            </h6>
                            <p-table *ngIf="!widgetLoader.tabletwo"
                                [columns]="colsTab2"
                                [value]="response.downloadTableData"
                                #dt2 [responsive]="true"
                                [rowsPerPageOptions]="[10]"
                                [paginator]="true"
                                [rows]="10">
                                <ng-template pTemplate="caption">
                                    <div class="row ml-10">
                                        <div class="col-md-12 pr3">
                                            <div class="input-group search-table">
                                                <input id="userDownloadData"
                                                aria-label="userDownloadData"
                                                type="search"
                                                class="se-form-control"
                                                title={{labels.appSearch}}
                                                placeholder="Search"
                                                (input)="dt2.filterGlobal($event.target.value, 'contains')">
                                                <span class="se-icon-action_search_stroke search_icon"></span>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th scope="col" *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width': col.width}">
                                            {{col.header}}
                                            <p-sortIcon [field]="col.field"
                                                ariaLabel="Activate to sort"
                                                ariaLabelDesc="Activate to sort in descending order"
                                                ariaLabelAsc="Activate to sort in ascending order">
                                            </p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-rowData let-columns="columns">
                                    <tr class="tbl-bodyrow">
                                        <td *ngFor="let col of columns" [ngStyle]="{'width': col.width}">
                                            <span class="txtWordWrap"   title="{{rowData[col.field]}}" *ngIf="col.field != 'timestamp'">
                                                {{rowData[col.field]}}
                                            </span>
                                            <span class="txtWordWrap"  title="{{rowData[col.field]}}" *ngIf="col.field == 'timestamp'">
                                                {{rowData[col.field] | date : 'yyyy-MM-dd  HH:mm:ss'}}
                                            </span>


                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="paginatorleft" let-state>

                                </ng-template>

                            </p-table>
                            <div class="text-center loader-box" *ngIf="widgetLoader.tabletwo">
                                <div class="se-loader mt-2 mb-2 ml-auto mr-auto"></div>
                            </div>
                        </div>
                    </div>
                    <div class="hide-in-large">
                        <div class="mobile-support">
                          <div class="container-fluid">
                            <div *ngIf="loading">
                              <div class="se-loader mrgAuto10"></div>
                            </div>
                            <div *ngIf="!loading">
                                <h6 class="widget-title font-weight-bold">
                                    {{labels.usersAppAccessdata}}
                                </h6>
                                <div class="row mt-4" style="margin-left: -8px;">
                                    <div class="col">
                                        <div class="input-group">
                                            <input id="usersAppAccessdata"
                                            aria-label="usersAppAccessdata"
                                            type="search"
                                            class="se-form-control search-input-tab ml-0"
                                            title={{labels.applicationSearch}}
                                            placeholder="Search"
                                            [(ngModel)]="searchText">
                                            <span class="se-icon-action_search_stroke search-icon-tab"></span>
                                        </div>
                                    </div>
                                    
                                    <div class="col-auto text-center">
                                        <em class="iconFntPosMobile"
                                            (click)="downloadTableOne()"
                                            (keypress)="downloadTableOne()"
                                            title="Download Tickets">
                                            <span class="se-icon-action_download_stroke"></span>
                                        </em>
                                    </div>
                                </div>
                                
                              <div class="row">
                                <div
                                  class="card-mobile support-card"
                                  *ngFor="let item of response.accessTableData | filter:searchText"
                                  [ngClass]="{
                                    danger: item.access === 'BLOCKED',
                                    warning: item.access === 'PENDING',
                                    'se-green': item.access === 'APPROVED'
                                  }"
                                >   
                                    <div class="row" style="padding-bottom: 18px;">
                                        <div class="col text-right">
                                            <div>
                                                <span class="pos-abs danger" *ngIf="item.access === 'BLOCKED'">
                                                    {{labels.blocked}}
                                                </span>
                                                <span class="pos-abs warning" *ngIf="item.access === 'PENDING'">
                                                    {{labels.pending}}
                                                </span>
                                                <span class="pos-abs se-green" *ngIf="item.access === 'APPROVED'">
                                                    {{labels.approved}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-6">
                                        <p>{{labels.name}} </p>
                                        <p class="main-t">{{ item.name }}</p>
                                        </div>
                                        <div class="col-6">
                                            <p>{{labels.iA3}}</p>
                                            <p class="main-t" style="word-break: break-word">{{ item.iA3  }}</p>
                                        </div>
                                        <div class="col-6">
                                            <p>{{labels.migrationExpert}}</p>
                                            <p class="main-t" style="word-break: break-word">{{ item.migrationExpert  }}</p>
                                        </div>
                                        <div class="col-6">
                                            <p>{{labels.plcConverter}}</p>
                                            <p class="main-t" style="word-break: break-word">{{ item.plcConverter  }}</p>
                                        </div>
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class="hide-in-large">
                        <div class="mobile-support">
                          <div class="container-fluid">
                            <div *ngIf="loading">
                              <div class="se-loader mrgAuto10"></div>
                            </div>
                            <div *ngIf="!loading && response?.downloadTableData.length">
                                <h6 class="widget-title font-weight-bold">
                                    {{labels.usersAppdownloaddata}}
                                </h6>
                                

                              <div class="row">
                                <div
                                  class="card-mobile support-card"
                                  *ngFor="let item of response.downloadTableData"
                                  [ngClass]="{
                                    danger: item.access === 'BLOCKED',
                                    warning: item.access === 'PENDING',
                                    'se-green': item.access === 'APPROVED'
                                  }"
                                 >
                                 <div class="row" style="padding-bottom: 18px;">
                                    <div class="col text-right">
                                        <div>
                                            <span class="pos-abs danger" *ngIf="item.access === 'BLOCKED'">
                                                {{labels.blocked}}
                                            </span>
                                            <span class="pos-abs warning" *ngIf="item.access === 'PENDING'">
                                                {{labels.pending}}
                                            </span>
                                            <span class="pos-abs se-green" *ngIf="item.access === 'APPROVED'">
                                                {{labels.approved}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                  <div class="row">
                                    <div class="col-6">
                                      <p class="main-t">{{labels.name}}</p>
                                      <p>{{ item.name }}</p>
                                    </div>
                                    <div class="col-6">
                                        <p class="main-t">{{labels.applictaionName}}</p>
                                        <p style="word-break: break-word">{{ item.applictaionName  }}</p>
                                      </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-6">
                                      <p class="main-t">{{labels.fileName}}</p>
                                      <p style="word-break: break-word">{{ item.fileName  }}</p>
                                    </div>
                                    <div class="col-6">
                                        <p class="main-t">{{labels.downloadedOn}}</p>
                                        <p style="word-break: break-word">{{ item.downloadedOn  }}</p>
                                      </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" [hidden]="gridView">
            <div class="col-sm-6 col-md-12 col-lg-6" style="padding-left: 13px;">
                <div class="widget">
                    <h6 class="widget-title font-weight-bold">
                        {{labels.usersCount}}
                        <em class="float-right downloadpdf hide-in-mob" title="Maximize" (click)="enterFS(bar)"><img width="16" height="16"
                                src="assets/image/presentation_mode.svg" alt="expand"></em>
                        <em class="float-right downloadpdf" title="Download chart" (click)="downloadChartOne()"><img
                                width="16" height="16" src="assets/image/download.svg" alt="download"></em>
                    </h6>
                    <div class="row m-0 align-items-top">
                        <div class="col-lg-12 col-xl-3 col-md-3 hide-in-mobile widget-left border-right p-0">
                            <div class="wl-first">
                                <div class="form-group">
                                    <select class="se-form-control" [(ngModel)]="barTimeSelection" (ngModelChange)="timeChangeBarGraph('barGraph')">
                                        <option *ngFor="let item of timeListDropGraph" value="{{item}}">{{item}}
                                        </option>
                                    </select>
                                </div>

                            </div>
                        </div>
                        <div class="col-12 hide-in-large widget-left p-0">
                            <div class="p-2">
                                <div class="form-group">
                                    <select class="se-form-control" [(ngModel)]="barTimeSelection" (ngModelChange)="timeChangeBarGraph('barGraph')">
                                        <option *ngFor="let item of timeListDropGraph" value="{{item}}">{{item}}
                                        </option>
                                    </select>
                                </div>

                            </div>
                        </div>
                        <div class="col-md-12 col-lg-9 widget-right p-0" style="height: 380px;">
                            <div class="col-md-6 widget-right p-0 hide-in-mobile">
                                <div class="se-loader" style="margin: 140px auto;margin-left: 200px;" *ngIf="widgetLoader.barGraphloaded"></div>
                            </div>
                            <div class="col-md-12 widget-right p-0 hide-in-large">
                                <div class="se-loader" style="margin: 140px auto;" *ngIf="widgetLoader.barGraphloaded"></div>
                            </div>
                            <div id="container" #bar style="min-width: 400px; height: 380px;" [hidden]="widgetLoader.barGraphloaded">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-12 col-lg-6" style="padding-left: 13px;">
                <div class="widget">
                    <h6 class="widget-title font-weight-bold">
                        {{labels.numberofUserswrtApp}}
                        <em class="float-right downloadpdf hide-in-mob" title="Maximize" (click)="enterFS(pie)"><img width="16" height="16"
                                src="assets/image/presentation_mode.svg" alt="expand"></em>
                        <em class="float-right downloadpdf" title="Download chart" (click)="downloadChartTwo()"><img
                                width="16" height="16" src="assets/image/download.svg" alt="download"></em>
                    </h6>
                    <div class="row m-0 align-items-top">
                        <div class="col-md-12 widget-right p-0">
                            <div class="col-md-12 widget-right p-0 hide-in-mobile" *ngIf="widgetLoader.pieGraphloaded">
                                <div class="se-loader" style="margin: 140px auto;margin-left: 300px;"></div>
                            </div>
                            <div class="col-md-12 widget-right p-0 hide-in-large" *ngIf="widgetLoader.pieGraphloaded">
                                <div class="se-loader" style="margin: 140px auto;"></div>
                            </div>
                            <div class="piechart-tab-view" id="PieChart" #pie style="min-width: 400px; height: 380px;" [hidden]="widgetLoader.pieGraphloaded">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>